import { Tool } from '../../types';

export const projectManagementTools: Tool[] = [
  {
    id: 'trello',
    name: 'Trello',
    category: 'Project Management',
    description: 'Visual project management and collaboration tool using intuitive Kanban boards. Organize tasks with drag-and-drop simplicity, set deadlines, assign team members, and track progress in real-time. Perfect for teams who prefer visual workflows.',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['agency', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['creative', 'technology', 'marketing'],
    website: 'https://trello.com',
    imageUrl: 'https://logo.clearbit.com/trello.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'procore',
    name: 'Procore',
    category: 'Project Management',
    description: 'Comprehensive construction management platform designed for Subcontractors, General Contractors and Developers',
    pricing: ['medium', 'high'],
    features: [
      'budget-tracking',
      'mobile',
      'scheduling',
      'task-management',
      'document-management',
      'change-order-management',
      'project-management',
      'timesheet-management'
    ],
    bestFor: ['trades', 'small-business'],
    compatibleWith: ['service-business', 'trades'],
    goals: ['streamline-operations', 'track-jobs', 'manage-scheduling'],
    industries: ['trades', 'home-services', 'construction'],
    website: 'https://www.procore.com',
    imageUrl: 'https://logo.clearbit.com/procore.com',
    idealStages: ['growing', 'scaling'],
    minTeamSize: 'small',
    technicalLevel: ['intermediate', 'advanced']
  },
  {
    id: 'asana',
    name: 'Asana',
    category: 'Project Management',
    description: 'Enterprise-grade work management platform that helps teams orchestrate work from daily tasks to strategic initiatives. Features timeline views, workload management, goal tracking, and powerful automation to keep projects on track.',
    pricing: ['free', 'medium', 'high'],
    features: ['automation', 'integrations', 'mobile'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['agency', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'marketing', 'creative'],
    website: 'https://asana.com',
    imageUrl: 'https://logo.clearbit.com/asana.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'monday',
    name: 'Monday.com',
    category: 'Project Management',
    description: 'Highly flexible Work OS that adapts to any workflow. Build custom project dashboards, automate repetitive tasks, visualize data with charts and timelines, and collaborate seamlessly across teams with real-time updates.',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'scalability'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['agency', 'service-business', 'saas', 'startup'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'marketing', 'creative'],
    website: 'https://try.monday.com/l9c1gebio4r7',
    imageUrl: 'https://logo.clearbit.com/monday.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'basecamp',
    name: 'Basecamp',
    category: 'Project Management',
    description: 'All-in-one project management and team communication platform with a refreshingly simple approach. Combines message boards, to-dos, schedules, docs, and group chat in one place. Flat pricing makes it budget-friendly for growing teams.',
    pricing: ['medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['agency', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['creative', 'technology', 'marketing'],
    website: 'https://basecamp.com',
    imageUrl: 'https://logo.clearbit.com/basecamp.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'jira',
    name: 'Jira',
    category: 'Project Management',
    description: 'Industry-leading project and issue tracking software for agile teams. Plan sprints, track bugs, manage backlogs, and generate detailed reports. Highly customizable with thousands of marketplace apps and deep developer tool integrations.',
    pricing: ['low', 'medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'scalability'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'agency', 'mobile-app'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'marketing'],
    website: 'https://www.atlassian.com/software/jira',
    imageUrl: 'https://logo.clearbit.com/atlassian.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  }
];